// extracted by mini-css-extract-plugin
export default {"content":"Alert_content__xmEIP","button":"Alert_button__paDm3","negative":"Alert_negative__GfASR"};